module.exports = __webpack_public_path__ + "static/szenario4_4-a42d1c3e786e3a867e5314eb071cbdc8.png";